module.exports = __webpack_public_path__ + "static/media/8.9c1c7052.jpeg";